<div class="title" mat-dialog-title>
  <div class="title-text">
    <span class="name">{{ imageData.titlePrefix }} for</span>
    <span class="bold"> "{{ imageData.title }}" </span>
  </div>
  <mat-icon mat-dialog-close>close</mat-icon>
</div>

<mat-dialog-content>
  <div class="logo-wrapper">
    <img [src]="imageData.imageUrl" />
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    class="cdx-but-md"
    color="primary"
    mat-stroked-button
    mat-dialog-close
  >
    Back
  </button>
</mat-dialog-actions>
